<template>
    <div class="publication-container">
        <div class="main-container">
            <el-skeleton :loading="loading" animated>
                <template slot="template">
                    <div style="padding: 32px 0;">
                        <el-skeleton-item variant="h3" style="width: 100%;" />
                        <div
                            style="display: flex; align-items: center; justify-items: space-between; margin: 16px 0; height: 16px;"
                        >
                            <el-skeleton-item variant="text" style="margin-right: 16px;" />
                            <el-skeleton-item variant="text" style="width: 30%;" />
                        </div>
                        <el-skeleton-item variant="h3" style="width: 100%;" />
                    </div>
                    <div style="padding: 32px 0;">
                        <el-skeleton-item variant="h3" style="width: 100%;" />
                        <div
                            style="display: flex; align-items: center; justify-items: space-between; margin: 16px 0; height: 16px;"
                        >
                            <el-skeleton-item variant="text" style="margin-right: 16px;" />
                            <el-skeleton-item variant="text" style="width: 30%;" />
                        </div>
                        <el-skeleton-item variant="h3" style="width: 100%;" />
                    </div>
                    <div style="padding: 32px 0;">
                        <el-skeleton-item variant="h3" style="width: 100%;" />
                        <div
                            style="display: flex; align-items: center; justify-items: space-between; margin: 16px 0; height: 16px;"
                        >
                            <el-skeleton-item variant="text" style="margin-right: 16px;" />
                            <el-skeleton-item variant="text" style="width: 30%;" />
                        </div>
                        <el-skeleton-item variant="h3" style="width: 100%;" />
                    </div>
                    <div style="padding: 32px 0;">
                        <el-skeleton-item variant="h3" style="width: 100%;" />
                        <div
                            style="display: flex; align-items: center; justify-items: space-between; margin: 16px 0; height: 16px;"
                        >
                            <el-skeleton-item variant="text" style="margin-right: 16px;" />
                            <el-skeleton-item variant="text" style="width: 30%;" />
                        </div>
                        <el-skeleton-item variant="h3" style="width: 100%;" />
                    </div>
                </template>
                <template>
                    <!-- <h1 class="title">{{ $t(`header.publication`) }}</h1> -->
                    <h1 class="title">代表论文</h1>
                    <h3 class="title">按年份排列 (Sorted by years)</h3>
                    <ul style="list-style-type: disc; padding-left: 20px;">
                        <li>
                            <h4 class="title">
                                <a href="#year-2024">2024</a>, 
                                <a href="#year-2023">2023</a>, 
                                <a href="#year-2022">2022</a>,
                                <a href="#year-2021">2021</a>,
                                <a href="#year-2020">2020</a>,
                                <a href="#year-2019">2019</a>,
                                <a href="#year-2018">2018</a>,
                                <a href="#year-2017">2017</a>
                            </h4>
                        </li>
                    </ul>

                    <h3 class="title">按领域排列 (Sorted by topics)</h3>
                    <ul style="list-style-type: disc; padding-left: 20px;">
                        <li>
                            <h4 class="title">
                                <a href="#topic-interdisciplinary">交叉 (Interdisciplinary)</a>,
                                <a href="#topic-AI">人工智能 (AI)</a>,
                                <a href="#topic-networking">网络 (Networking)</a>,
                                <a href="#topic-sensing">感知 (Sensing)</a>,
                                <a href="#topic-theory">理论 (Theory)</a>
                            </h4>
                        </li>
                    </ul>
                    
                    <!-- <h3 class="title">
                    <a href="#topic-interdisciplinary">交叉 (Interdisciplinary)</a>,
                    <a href="#topic-AI">人工智能 (AI)</a>,
                    <a href="#topic-networking">网络 (Networking)</a>,
                    <a href="#topic-sensing">感知 (Sensing)</a>,
                    <a href="#topic-theory">理论 (Theory)</a>
                    </h3> -->
                    <h3 class="title">For the complete list, please refer to <a href="https://dblp.org/pid/96/1149.html">DBLP</a>.</h3>
                    

                    <!-- <ul style="list-style-type: disc; padding-left: 20px;">
                        <li>
                            <h4 class="title">年份：
                                <a href="#year-2024">2024</a>, 
                                <a href="#year-2023">2023</a>, 
                                <a href="#year-2022">2022</a>,
                                <a href="#year-2021">2021</a>,
                                <a href="#year-2020">2020</a>,
                                <a href="#year-2019">2019</a>,
                                <a href="#year-2018">2018</a>,
                                <a href="#year-2017">2017</a>
                            </h4>
                        </li>
                    </ul> -->

                    <h4 id="year-2024" class="title">{{ $t(`2024`) }}</h4>
                    <ul class="publication-list">
                        <li class="publication-item" v-for="(item, index) in filteredPublicationList2024" :key="index"><span style="font-weight: bold;">【{{ item.venue.split(' ').slice(0, -1).join(' ')  }}-{{ item.year }}】</span> {{ item.citation}}</li>
                    </ul>
                    <h4 id="year-2023" class="title">{{ $t(`2023`) }}</h4>
                    <ul class="publication-list">
                        <li class="publication-item" v-for="(item, index) in filteredPublicationList2023" :key="index"><span style="font-weight: bold;">【{{ item.venue.split(' ').slice(0, -1).join(' ')  }}-{{ item.year }}】</span> {{ item.citation }}</li>
                    </ul>
                    <h4 id="year-2022" class="title">{{ $t(`2022`) }}</h4>
                    <ul class="publication-list">
                        <li class="publication-item" v-for="(item, index) in filteredPublicationList2022" :key="index"><span style="font-weight: bold;">【{{ item.venue.split(' ').slice(0, -1).join(' ')  }}-{{ item.year }}】</span> {{ item.citation }}</li>
                    </ul>
                    <h4 id="year-2021" class="title">{{ $t(`2021`) }}</h4>
                    <ul class="publication-list">
                        <li class="publication-item" v-for="(item, index) in filteredPublicationList2021" :key="index"><span style="font-weight: bold;">【{{ item.venue.split(' ').slice(0, -1).join(' ')  }}-{{ item.year }}】</span> {{ item.citation }}</li>
                    </ul>
                    <h4 id="year-2020" class="title">{{ $t(`2020`) }}</h4>
                    <ul class="publication-list">
                        <li class="publication-item" v-for="(item, index) in filteredPublicationList2020" :key="index"><span style="font-weight: bold;">【{{ item.venue.split(' ').slice(0, -1).join(' ')  }}-{{ item.year }}】</span> {{ item.citation }}</li>
                    </ul>
                    <h4 id="year-2019" class="title">{{ $t(`2019`) }}</h4>
                    <ul class="publication-list">
                        <li class="publication-item" v-for="(item, index) in filteredPublicationList2019" :key="index"><span style="font-weight: bold;">【{{ item.venue.split(' ').slice(0, -1).join(' ')  }}-{{ item.year }}】</span> {{ item.citation }}</li>
                    </ul>
                    <h4 id="year-2018" class="title">{{ $t(`2018`) }}</h4>
                    <ul class="publication-list">
                        <li class="publication-item" v-for="(item, index) in filteredPublicationList2018" :key="index"><span style="font-weight: bold;">【{{ item.venue.split(' ').slice(0, -1).join(' ') }}-{{ item.year }}】</span> {{ item.citation }}</li>
                    </ul>
                    <h4 id="year-2017" class="title">{{ $t(`2017`) }}</h4>
                    <ul class="publication-list">
                        <li class="publication-item" v-for="(item, index) in filteredPublicationList2017" :key="index"><span style="font-weight: bold;">【{{ item.venue.split(' ').slice(0, -1).join(' ')  }}-{{ item.year }}】</span> {{ item.citation }}</li>
                    </ul>
                    

                    <ul>
                        <li>
                            <h4 class="title">领域：
                                <a href="#topic-interdisciplinary">交叉 (Interdisciplinary)</a>,
                                <a href="#topic-AI">人工智能 (AI)</a>,
                                <a href="#topic-networking">网络 (Networking)</a>,
                                <a href="#topic-sensing">感知 (Sensing)</a>,
                                <a href="#topic-theory">理论 (Theory)</a>
                            </h4>
                        </li>
                    </ul>

                    <h4 id="topic-interdisciplinary" class="title">{{ $t(`交叉 (Interdisciplinary)`) }}</h4>
                    <ul class="publication-list">
                        <li class="publication-item" v-for="(item, index) in filteredPublicationListInt" :key="index"><span style="font-weight: bold;">【{{ item.venue.split(' ').slice(0, -1).join(' ')  }}-{{ item.year }}】</span> {{ item.citation }}</li>
                    </ul>
                    <h4 id="topic-AI" class="title">{{ $t(`人工智能 (AI)`) }}</h4>
                    <ul class="publication-list">
                        <li class="publication-item" v-for="(item, index) in filteredPublicationListAI" :key="index"><span style="font-weight: bold;">【{{ item.venue.split(' ').slice(0, -1).join(' ') }}-{{ item.year }}】</span> {{ item.citation }}</li>
                    </ul>
                    <h4 id="topic-networking" class="title">{{ $t(`网络 (Networking)`) }}</h4>
                    <ul class="publication-list">
                        <li class="publication-item" v-for="(item, index) in filteredPublicationListNet" :key="index"><span style="font-weight: bold;">【{{ item.venue.split(' ').slice(0, -1).join(' ') }}-{{ item.year }}】</span> {{ item.citation }}</li>
                    </ul>
                    <h4 id="topic-sensing" class="title">{{ $t(`感知 (Sensing)`) }}</h4>
                    <ul class="publication-list">
                        <li class="publication-item" v-for="(item, index) in filteredPublicationListSen" :key="index"><span style="font-weight: bold;">【{{ item.venue.split(' ').slice(0, -1).join(' ') }}-{{ item.year }}】</span> {{ item.citation }}</li>
                    </ul>
                    <h4 id="topic-theory" class="title">{{ $t(`理论 (Theory)`) }}</h4>
                    <ul class="publication-list">
                        <li class="publication-item" v-for="(item, index) in filteredPublicationListThe" :key="index"><span style="font-weight: bold;">【{{ item.venue.split(' ').slice(0, -1).join(' ') }}-{{ item.year }}】</span> {{ item.citation }}</li>
                    </ul>

                   
                    <!-- <div
                        ref="scrollTopButton"
                        class="invisible sticky w-full flex justify-end bottom-0 pb-3 pr-5 lg:pr-16 transition"
                    >
                        <div
                            class="text-gray-400 hover:text-blue-400 transition"
                        >
                            <button @click="scrollToTop">
                                Scroll to top
                            </button>
                        </div>
                    </div> -->
                </template>
                <!-- <button onclick="topFunction()" id="myBtn" title="Go to top">Top</button> -->
            </el-skeleton>
            <!-- <button onclick="topFunction()" id="myBtn" title="Go to top">Top</button> -->
        </div>
    </div>
    <!-- Create a button that will take the user to the top of the page when clicked on -->

</template>


<script>
import { fetchPaperList } from '@/api/message'
export default {
    data() {
        return {
            loading: false,
            publicationlList: []
        }
    },
    mounted() {
        this.initData()
    },
    methods: {
        initData() {
            fetchPaperList().then(res => {
                this.publicationlList = res.data || []
            })
        },
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
    },
    computed: {
        filteredPublicationList2024() {
            return this.publicationlList.filter(item => item.year == "2024");
        },
        filteredPublicationList2023() {
            return this.publicationlList.filter(item => item.year == "2023");
        },
        filteredPublicationList2022() {
            return this.publicationlList.filter(item => item.year == "2022");
        },
        filteredPublicationList2021() {
            return this.publicationlList.filter(item => item.year == "2021");
        },
        filteredPublicationList2020() {
            return this.publicationlList.filter(item => item.year == "2020");
        },
        filteredPublicationList2019() {
            return this.publicationlList.filter(item => item.year == "2019");
        },
        filteredPublicationList2018() {
            return this.publicationlList.filter(item => item.year == "2018");
        },
        filteredPublicationList2017() {
            return this.publicationlList.filter(item => item.year == "2017");
        },
        filteredPublicationListInt() {
            // i want filter the venue by the last word of the venue and the year from newest to oldest
            return this.publicationlList.filter(item => item.venue.split(' ').slice(-1)[0] == "int").sort((a, b) => parseInt(b.year) - parseInt(a.year));
            // return this.publicationlList.filter(item => item.venue.split(' ').slice(-1)[0] == "int");

        },
        filteredPublicationListAI() {
            return this.publicationlList.filter(item => item.venue.split(' ').slice(-1)[0] == "AI").sort((a, b) => parseInt(b.year) - parseInt(a.year));
        },
        filteredPublicationListNet() {
            return this.publicationlList.filter(item => item.venue.split(' ').slice(-1)[0] == "net").sort((a, b) => parseInt(b.year) - parseInt(a.year));
        },
        filteredPublicationListSen() {
            return this.publicationlList.filter(item => item.venue.split(' ').slice(-1)[0] == "sen").sort((a, b) => parseInt(b.year) - parseInt(a.year));
        },
        filteredPublicationListThe() {
            return this.publicationlList.filter(item => item.venue.split(' ').slice(-1)[0] == "the").sort((a, b) => parseInt(b.year) - parseInt(a.year));
        },
    }
}

</script>


<script setup>
  import { onMounted, onUnmounted, ref } from "vue";

  let scrollTopButton = ref(null);

  const handleScroll = () => {
    if (window.scrollY > 0) {
      scrollTopButton.value.classList.remove("invisible");
    } else {
      scrollTopButton.value.classList.add("invisible");
    }
  };

  onMounted(() => {
    window.addEventListener("scroll", handleScroll);
  });

  onUnmounted(() => {
    window.removeEventListener("scroll", handleScroll);
  });
</script>


<style lang="less" scoped>
.publication-container {
    background: #ededed;
    min-height: calc(100vh - 255px);
    text-align: left;
    .main-container {
        padding: 32px 0;
    }
    .title {
        font-size: 28px;
        font-weight: 900;
        margin-bottom: 36px;
    }
    .publication-item {
        line-height: 20px;
        margin-bottom: 20px;
    }
}
</style>

